'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.union.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.union.v2.js
// module id = 1515
// module chunks = 0